
export class SchedulingWhats {
    constructor({
                    //attributes
                    id= null,
                    completed= 0,
                    message= '',
                    destination_number= null,
                    type= null,
                    title= '',
                    date= null,
                    has_alert= null,
                    created_at= new Date(),
                    updated_at= new Date(),
                    deleted_at= null,
                } = {}) {

        //fill attributes
        this.id=id;
        this.completed=completed;
        this.message=message;
        this.destination_number=destination_number;
        this.type=type;
        this.title=title;
        this.date=date;
        this.has_alert=has_alert;
        this.created_at=created_at;
        this.updated_at=updated_at;
        this.deleted_at=deleted_at;

    }

}

export function createSchedulingWhats(data={}) {
    return Object.freeze(new SchedulingWhats(data));
}